import {identity} from '@packages/utilities/fp/utils';
import {type InternalPlugins} from './PluginTypes';

// Opaque type removed - see /packages/utilities/type-safety/README.md for more information
export type PluginsType = InternalPlugins;

export const toPlugins: (arg1: InternalPlugins) => PluginsType = identity;

export const getPluginsDataTypes = (plugins: PluginsType) => plugins.dataTypes;
export const getPlugins__DEPRECATED__DataTypes = (plugins: PluginsType) =>
  plugins.__DEPRECATED__dataTypes;
export const getPluginsValues = (plugins: PluginsType) => plugins.values;
export const getPluginsAssets = (plugins: PluginsType) => plugins.assets;
export const getPluginsComponents = (plugins: PluginsType) =>
  plugins.components;
export const getPluginsAtoms = (plugins: PluginsType) => plugins.atoms;
export const getPluginsIcons = (plugins: PluginsType) => plugins.icons;
export const getPluginsElementPresets = (plugins: PluginsType) =>
  plugins.elementPresets;
export const getPluginsValuePresets = (plugins: PluginsType) =>
  plugins.valuePresets;
export const getPluginsElementTypeToPluginNameMap = (plugins: PluginsType) =>
  plugins.elementTypeToPluginNameMap;
export const getPluginsImportStrategyMap = (plugins: PluginsType) =>
  plugins.importStrategyMap;
export const getPluginsStyleVariables = (plugins: PluginsType) =>
  plugins.styleVariables;
export const getPluginsStyleVariableCollections = (plugins: PluginsType) =>
  plugins.styleVariableCollections;
export const getPluginsStyleBlocks = (plugins: PluginsType) =>
  plugins.styleBlocks;
export const getPluginsSlugMap = (plugins: PluginsType) => plugins.slugMap;
export const getPluginsSiteModuleDependencies = (plugins: PluginsType) =>
  plugins.siteModuleDependencies;
